import React from "react";

import Condition from "../Conditional/Condition";
import "./CartBadge.scss";

export interface ICartBadgeProps {
	"data-testid"?: string;
	children?: React.ReactNode;
	className?: string;
	totalQuantity: number;
}

const getBadgeSizeClass = (quantity: number): string => {
	if (quantity >= 100) return "Large"; // 3 digits (99+)
	if (quantity >= 10) return "Medium";

	return "";
};

const CartBadge: React.FC<ICartBadgeProps> = (props) => {
	const { totalQuantity, children, className } = props;

	return (
		<div className={`CartBadge ${className || ""}`} data-testid={props["data-testid"]}>
			{children}
			<Condition check={totalQuantity > 0}>
				<span className={`CartBadgeBadge ${getBadgeSizeClass(totalQuantity)}`}>
					{totalQuantity > 99 ? "99+" : totalQuantity}
				</span>
			</Condition>
		</div>
	);
};

export default CartBadge;
